// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapping-ai {
  height: 25px;
  width: 25px;
  border-radius: 10px;
  background: #8f20a9;
  background: linear-gradient(90deg, #8f20a9 0%, #4444b3 100%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.mapping-ai-inner {
  height: 18px;
  width: 18px;
  border-radius: 6px;
  border-color: #fff;
  border-style: solid;
  border-width: 2px;
  background-color: transparent;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapping-ai-color {
  color: #8f20a9;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/LLMQuestionAnswerElement/LLMQuestionAnswerElement.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,4DAAA;EAKA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHF;;AAKA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAIA;EACE,cAAA;EACA,gBAAA;AADF","sourcesContent":[".mapping-ai {\n  height: 25px;\n  width: 25px;\n  border-radius: 10px;\n  background: rgb(143, 32, 169);\n  background: linear-gradient(\n    90deg,\n    rgba(143, 32, 169, 1) 0%,\n    rgba(68, 68, 179, 1) 100%\n  );\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.mapping-ai-inner {\n  height: 18px;\n  width: 18px;\n  border-radius: 6px;\n  border-color: #fff;\n  border-style: solid;\n  border-width: 2px;\n  background-color: transparent;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.mapping-ai-color {\n  color: rgb(143, 32, 169);\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
